module.exports = __webpack_public_path__ + "static/media/jared-tarbell-2.6ef95dc4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/presentation/jared-tarbell-2.jpg
// module id = 429
// module chunks = 12